import { AppConfig, Environment } from './config.model';

export const appConfig: AppConfig = {
    production: false,
    env: Environment.Qa,
    auth: {
        config: {
            authority:
                'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/v2.0',
            authWellknownEndpointUrl:
                'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/v2.0/.well-known/openid-configuration',
            redirectUrl: window.location.origin,
            clientId: 'c1328646-1c8d-483d-a92a-f29a9108d21c',
            scope: 'c1328646-1c8d-483d-a92a-f29a9108d21c/.default openid offline_access email profile',
            responseType: 'code',
            silentRenew: true,
            silentRenewTimeoutInSeconds: 60, // 1 minute for testing
            useRefreshToken: true,
            maxIdTokenIatOffsetAllowedInSeconds: 600,
            renewTimeBeforeTokenExpiresInSeconds: 3300,
            ignoreNonceAfterRefresh: true,
            issValidationOff: false,
            autoUserInfo: false,
        },
    },
    webchat: {
        baseUrl: 'https://api.qa.commerce.basf.com/copilot-int',
        scriptUrl: 'https://microfrontends.staging.wxp.basf.com/my-basf-navigator/chatbot.js',
        apiKey: '53tLKUjPuB2zyt5oNXw8O47CcgH6a4el2UqxldLi',
        showSessionId: true,
        useStreaming: true,
    },
};
